import { useEffect, useState } from 'react';
import { flushSync } from 'react-dom';

/**
 * True from `beforeprint` to `afterprint`. The switch is rendered synchronously, so whatever
 * it mounts exists before the browser captures the page.
 */
export function usePrinting(): boolean {
  const [printing, setPrinting] = useState(false);
  useEffect(() => {
    const start = () => flushSync(() => setPrinting(true));
    const stop = () => setPrinting(false);
    window.addEventListener('beforeprint', start);
    window.addEventListener('afterprint', stop);
    return () => {
      window.removeEventListener('beforeprint', start);
      window.removeEventListener('afterprint', stop);
    };
  }, []);
  return printing;
}
